import * as React from 'react';
import DatePicker from "react-datepicker";
import styles from './DateRangeSelector.module.scss';

import "react-datepicker/dist/react-datepicker.css";
import { Dropdown } from 'semantic-ui-react';
import { DateRangeEnum } from '.';
import { DateTime } from 'luxon';

interface IDateRangeSelectorProps {
    startDate: string,
    endDate: string
}

interface IDateRangeSelectorState {
    startDate?: Date;
    endDate?: Date;
}



export class DateRangeSelector extends React.Component<IDateRangeSelectorProps, IDateRangeSelectorState> {
    constructor(props: IDateRangeSelectorProps) {
        super(props);
        this.state = {
            startDate: undefined,
            endDate: undefined
        };
    }

    componentDidUpdate(prevProps: IDateRangeSelectorProps, prevState: IDateRangeSelectorState) {
        if (this.props != prevProps) {
            if (this.props.startDate != 'null') {
                let _sd = new Date(this.props.startDate) || undefined;
                this.setState({startDate: _sd})
            }

            if(this.props.endDate != 'null'){
            let _ed = new Date(this.props.endDate) || undefined;
            this.setState({endDate: _ed})
            }
        }

        if (this.state != prevState) {
            localStorage.setItem('startDate', JSON.stringify(this.state.startDate || 'null'));
            localStorage.setItem('endDate', JSON.stringify(this.state.endDate) || 'null');
        }
    }

    private handleStartChange(date: any) {
        this.setState({
            startDate: date
        });
    }
    private handleEndChange(date: any) {
        
        this.setState({
            endDate: date
        });
    }

    public render() {
        const { startDate, endDate } = this.state;
        const dateRangePredefined = [
            {key: DateRangeEnum.Custom, value: DateRangeEnum.Custom, text: 'Custom'},
            {key: DateRangeEnum.LastWeek, value: DateRangeEnum.LastWeek, text: 'Last 7 days'},
            {key: DateRangeEnum.LastMonth, value: DateRangeEnum.LastMonth, text: 'Last 30 days'},
            {key: DateRangeEnum.LastYear, value: DateRangeEnum.LastYear, text: 'Last Year'}
        ]

        return (
            <>
                <Dropdown 
                    fluid
                    selection
                    aria-label='Search Date Range Select'
                    options={dateRangePredefined}
                    defaultValue={dateRangePredefined[0].value}
                    className={styles.dropdownSelection}
                    onChange={(e, b) => this.getSelected(b.value)}
                />
                <div className={styles.datePickerSelection}>
                    <DatePicker
                        selected={startDate}
                        onChange={date => this.handleStartChange(date)}
                        selectsStart
                        dateFormat="MM/yyyy"
                        startDate={startDate}
                        endDate={endDate}
                        className={styles.datePicker}
                        placeholderText='MM/YYYY'
                        showMonthYearPicker
                    />
                    <DatePicker
                        selected={endDate}
                        onChange={date => this.handleEndChange(date)}
                        selectsEnd
                        dateFormat="MM/yyyy"
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className={styles.datePicker}
                        placeholderText='MM/YYYY'
                        showMonthYearPicker
                    />
                </div>
            </>
        )
    }

    private getSelected(selected: any) {
        let _startDate = DateTime.local();
        let _endDate = undefined;

        switch (selected) {
            case DateRangeEnum.LastWeek: 
                _startDate = _startDate.minus({days: 7});
                _endDate = new Date();
                break;
            case DateRangeEnum.LastMonth:
                _startDate = _startDate.minus({month: 1});
                _endDate = new Date();
                break;
            case DateRangeEnum.LastYear:
                _startDate = _startDate.minus({year: 1});
                _endDate = new Date();
                break;
            default:
                break;
        }

        let newDate = new Date(_startDate.toISODate());

        this.setState({
            startDate: newDate,
            endDate: _endDate
        })
    }
}